/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, color, replacePXinStringWithEM, spacing, heights, mediaQuery } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// REWARDS INDICATOR : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	rewardsindicator: {
		// outline: '1px solid #ccc',
		display: 'table',
		width: '100%',
		height: hasRewardsComponent => hasRewardsComponent ? pxToEm(70) : '0em', // 74 // only set a height if rewards are enabled,
		padding: replacePXinStringWithEM(`0px ${spacing.sides} 0px`), // top and bottom on header and footer
		position: 'absolute',
		bottom: '0', //heights.footer,
		left: '0',
		zIndex: '4',

		// ..... GROUP HELPER ..... //
		'& .group': {
			display: 'table-cell',
			verticalAlign: 'middle',
			'&:nth-child(1)': { 
				paddingRight: pxToEm(10)
			},
			'&:nth-child(2)': { 
				width: pxToEm(76), // 66
				textAlign: 'right'
			}
		},

		// ..... POINT STATUS ..... //
		'& .pointstatus': {
			display: 'inline-block',
			verticalAlign: 'middle',

			// TEXT
			'& .pointstatustext': {
				fontSize: pxToEm(10),
				fontWeight: '600',
				marginBottom: pxToEm(3)
			},

			// BAR
			'& .pointstatusbar': {
				marginBottom: pxToEm(4),
				width: '70%', //pxToEm(132),
				height: pxToEm(8),
	  			borderRadius: pxToEm(6),
	  			border: replacePXinStringWithEM(`solid 2px ${color.rewards}`),
	  			transition: 'all .2s ease-in 0s',
	  			'&.pointsAwarded-true': {
	  				boxShadow: replacePXinStringWithEM(`0 0 22px 0 ${color.rewards}`)
	  			},
	  			'& .bar': { 
	  				borderRadius: 'inherit',
	  				height: '100%'
	  			},
	  			'& .foreground': {
	  				backgroundColor: color.rewards,
	  				width: '50%', // dynamically changed via state updates in component as inline style
	  				transition: 'width .3s ease-in 0s'
	  			},
	  			'& .background': {
	  				backgroundColor: 'transparent',
	  				width: '100%'
	  			}
			},

			// MESSAGE
			'& .pointstatusmessage': {
				// maxWidth: '100%',
				fontSize: pxToEm(10),
				fontWeight: '600',
				lineHeight: 1.4,
				'& .reward': {
					whiteSpace: 'nowrap'
				}
			}
		},

		// ..... DISCLAIMER ..... //
		'& .disclaimer': {
            '&.amazon': {
                fontSize: pxToEm(6),
                lineHeight: 1.2,
                marginTop: pxToEm(5),
                '& a': {
                    color: color.white,
                    whiteSpace: 'nowrap',
                    textDecoration: 'none'
                }
            },
            '&.generic': {
                display: 'none'
            }
		},

		// ..... STATES ..... //
		'&.show-false': {
			display: 'none'
		},
		'&.rewardAvailable-initial': {
			'& .pointstatusbar': {
				animationName: 'headShake',
	            animationDelay: '0s',
	            animationDuration: '.9s',
	            animationFillMode: 'forwards'
	        }
		},
		'&.rewardAvailable-updated': {
			extend: '&.rewardAvailable-initial'
		}
	},
	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.wide]: {
        rewardsindicator: { '& .group': { fontSize: '110%' } }
    },
    [mediaQuery.thin]: {
		rewardsindicator: { '& .group': { fontSize: '95%' } }
	}
};